module.exports = __webpack_public_path__ + "img/xiaodang_huishou@3x.6ddc4e45.png";